const SMALL = 'small';
const LARGE = 'large';
const BASE_PATH = 'leisure_destinations';
const AIRHAIFA_BASE_PATH = `${BASE_PATH}/airhaifa`;

const DESTINATIONS_BASE_DATA = {
    Dubai: {
        title: 'TopDestinations.Dubai',
        sub_title: 'TopDestinations.Dubai_Subtitle',
        destination: {
            "address": "Dubai - United Arab Emirates",
            "place": {
                "description": "Dubai - United Arab Emirates",
                "place_id": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "reference": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Dubai",
                "label": "Dubai, United Arab Emirates",
                "address": "Dubai - United Arab Emirates",
                "short_address": "United Arab Emirates",
                "index": -1,
                "address_components": [
                    { "long_name": "Dubai", "short_name": "Dubai", "types": ["locality", "political"] },
                    { "long_name": "Dubai", "short_name": "Dubai", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "United Arab Emirates", "short_name": "AE", "types": ["country", "political"] }
                ],
                "formatted_address": "Dubai - United Arab Emirates",
                "geometry": {
                    "location": { "lat": 25.2048493, "lng": 55.2707828 },
                    "viewport": {
                        "northeast": { "lat": 25.35856066265986, "lng": 55.5650392624228 },
                        "southwest": { "lat": 24.79348418590246, "lng": 54.89045432509004 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 25.2048493, "lng": 55.2707828 },
                "viewport": {
                    "northeast": { "lat": 25.35856066265986, "lng": 55.5650392624228 },
                    "southwest": { "lat": 24.79348418590246, "lng": 54.89045432509004 }
                }
            }
        }
    },
    NewYork: {
        title: 'TopDestinations.NewYork',
        sub_title: 'TopDestinations.NewYork_Subtitle',
        destination: {
            "address": "New York, NY, USA",
            "place": {
                "description": "New York, NY, USA",
                "place_id": "ChIJOwg_06VPwokRYv534QaPC8g",
                "reference": "ChIJOwg_06VPwokRYv534QaPC8g",
                "types": ["locality", "political"],
                "category": "location",
                "name": "New York",
                "label": "New York, NY, USA",
                "address": "New York, NY, USA",
                "short_address": "NY, USA",
                "index": -1,
                "address_components": [
                    { "long_name": "New York", "short_name": "New York", "types": ["locality", "political"] },
                    { "long_name": "New York", "short_name": "NY", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "United States", "short_name": "US", "types": ["country", "political"] }
                ],
                "formatted_address": "New York, NY, USA",
                "geometry": {
                    "location": { "lat": 40.7127753, "lng": -74.0059728 },
                    "viewport": {
                        "northeast": { "lat": 40.91757705070789, "lng": -73.70027206817629 },
                        "southwest": { "lat": 40.47739906045452, "lng": -74.25908991427882 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 40.7127753, "lng": -74.0059728 },
                "viewport": {
                    "northeast": { "lat": 40.91757705070789, "lng": -73.70027206817629 },
                    "southwest": { "lat": 40.47739906045452, "lng": -74.25908991427882 }
                }
            }
        }
    },
    London: {
        title: 'TopDestinations.London',
        sub_title: 'TopDestinations.Subtitle3',
        destination: {
            "address": "London, UK",
            "place": {
                "description": "London, UK",
                "place_id": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                "reference": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                "types": ["locality", "political"],
                "category": "location",
                "name": "London",
                "label": "London, UK",
                "address": "London, UK",
                "short_address": "UK",
                "index": -1,
                "address_components": [
                    { "long_name": "London", "short_name": "London", "types": ["locality", "political"] },
                    { "long_name": "London", "short_name": "London", "types": ["postal_town"] },
                    { "long_name": "Greater London", "short_name": "Greater London", "types": ["administrative_area_level_2", "political"] },
                    { "long_name": "England", "short_name": "England", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "United Kingdom", "short_name": "GB", "types": ["country", "political"] }
                ],
                "formatted_address": "London, UK",
                "geometry": {
                    "location": { "lat": 51.5072178, "lng": -0.1275862 },
                    "viewport": {
                        "northeast": { "lat": 51.67234324898703, "lng": 0.1482710335611201 },
                        "southwest": { "lat": 51.38494012429096, "lng": -0.3514683384218145 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 51.5072178, "lng": -0.1275862 },
                "viewport": {
                    "northeast": { "lat": 51.67234324898703, "lng": 0.1482710335611201 },
                    "southwest": { "lat": 51.38494012429096, "lng": -0.3514683384218145 }
                }
            }
        }
    },
    Athens: {
        title: 'TopDestinations.Athens',
        sub_title: 'TopDestinations.Athens_Subtitle',
        destination: {
            "address": "Athens, Greece",
            "place": {
                "description": "Athens, Greece",
                "place_id": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                "reference": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Athens",
                "label": "Athens, Greece",
                "address": "Athens, Greece",
                "short_address": "Greece",
                "index": -1,
                "address_components": [
                    { "long_name": "Athens", "short_name": "Athens", "types": ["locality", "political"] },
                    { "long_name": "Central Athens Regional Unit", "short_name": "Central Athens Regional Unit", "types": ["administrative_area_level_3", "political"] },
                    { "long_name": "Greece", "short_name": "GR", "types": ["country", "political"] }
                ],
                "formatted_address": "Athens, Greece",
                "geometry": {
                    "location": { "lat": 37.9838096, "lng": 23.7275388 },
                    "viewport": {
                        "northeast": { "lat": 38.03285634274878, "lng": 23.7896925212467 },
                        "southwest": { "lat": 37.94881814647892, "lng": 23.68698615988247 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 37.9838096, "lng": 23.7275388 },
                "viewport": {
                    "northeast": { "lat": 38.03285634274878, "lng": 23.7896925212467 },
                    "southwest": { "lat": 37.94881814647892, "lng": 23.68698615988247 }
                }
            }
        }
    },
    KohSamui: {
        title: 'TopDestinations.KohSamui',
        sub_title: 'TopDestinations.KohSamui_Subtitle',
        destination: {
            "address": "Koh Samui, Thailand",
            "place": {
                "description": "Koh Samui, Ko Samui District, Surat Thani, Thailand",
                "place_id": "ChIJcyZmHFDxVDAR0IA2LLwjAgM",
                "reference": "ChIJcyZmHFDxVDAR0IA2LLwjAgM",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Koh Samui",
                "label": "Koh Samui, Thailand",
                "address": "Koh Samui, Thailand",
                "short_address": "Koh Samui",
                "index": -1,
                "address_components": [
                    { "long_name": "Koh Samui", "short_name": "Koh Samui", "types": ["locality", "political"] },
                    { "long_name": "Ko Samui District", "short_name": "Ko Samui District", "types": ["administrative_area_level_2", "political"] },
                    { "long_name": "Surat Thani", "short_name": "จ.สุราษฎร์ธานี", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "Thailand", "short_name": "TH", "types": ["country", "political"] }
                ],
                "formatted_address": "Koh Samui, Ko Samui District, Surat Thani, Thailand",
                "geometry": {
                    "location": { "lat": 9.5214157, "lng": 100.0482144 },
                    "viewport": {
                        "northeast": { "lat": 9.801232439702698, "lng": 100.0906548371837 },
                        "southwest": { "lat": 9.300729270441792, "lng": 99.65013441956222 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 9.5214157, "lng": 100.0482144 },
                "viewport": {
                    "northeast": { "lat": 9.801232439702698, "lng": 100.0906548371837 },
                    "southwest": { "lat": 9.300729270441792, "lng": 99.65013441956222 }
                }
            }
        }
    },
    Budapest: {
        title: 'TopDestinations.Budapest',
        sub_title: 'TopDestinations.Budapest_Subtitle',
        destination: {
            "address": "Budapest, Hungary",
            "place": {
                "description": "Budapest, Hungary",
                "place_id": "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
                "reference": "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Budapest",
                "label": "Budapest, Hungary",
                "address": "Budapest, Hungary",
                "short_address": "Hungary",
                "index": -1,
                "address_components": [
                    { "long_name": "Budapest", "short_name": "Budapest", "types": ["locality", "political"] },
                    { "long_name": "Hungary", "short_name": "HU", "types": ["country", "political"] }
                ],
                "formatted_address": "Budapest, Hungary",
                "geometry": {
                    "location": { "lat": 47.497912, "lng": 19.040235 },
                    "viewport": {
                        "northeast": { "lat": 47.61301194615275, "lng": 19.33450493254384 },
                        "southwest": { "lat": 47.34941504569791, "lng": 18.92610106630945 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 47.497912, "lng": 19.040235 },
                "viewport": {
                    "northeast": { "lat": 47.61301194615275, "lng": 19.33450493254384 },
                    "southwest": { "lat": 47.34941504569791, "lng": 18.92610106630945 }
                }
            }
        }
    },
    Rhodes: {
        title: 'TopDestinations.Rhodes',
        sub_title: 'TopDestinations.Rhodes_Subtitle',
        destination: {
            "address": "Rhodes, Greece",
            "place": {
                "description": "Rhodes, Greece",
                "place_id": "ChIJYf8K4ZNhlRQRk4i_vYjQE2k",
                "reference": "ChIJYf8K4ZNhlRQRk4i_vYjQE2k",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Rhodes",
                "label": "Rhodes, Greece",
                "address": "Rhodes, Greece",
                "short_address": "Greece",
                "index": -1,
                "address_components": [
                    { "long_name": "Rhodes", "short_name": "Rhodes", "types": ["locality", "political"] },
                    { "long_name": "Rhodes", "short_name": "Rhodes", "types": ["administrative_area_level_3", "political"] },
                    { "long_name": "Greece", "short_name": "GR", "types": ["country", "political"] }
                ],
                "formatted_address": "Rhodes, Greece",
                "geometry": {
                    "location": { "lat": 36.4359325, "lng": 28.2172676 },
                    "viewport": {
                        "northeast": { "lat": 36.4586052237461, "lng": 28.24081820191253 },
                        "southwest": { "lat": 36.41289633176704, "lng": 28.20258754462017 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 36.4359325, "lng": 28.2172676 },
                "viewport": {
                    "northeast": { "lat": 36.4586052237461, "lng": 28.24081820191253 },
                    "southwest": { "lat": 36.41289633176704, "lng": 28.20258754462017 }
                }
            }
        }
    },
    Paris: {
        title: 'TopDestinations.Paris',
        sub_title: 'TopDestinations.Paris_Subtitle',
        destination: {
            "address": "Paris, France",
            "place": {
                "description": "Paris, France",
                "place_id": "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                "reference": "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Paris",
                "label": "Paris, France",
                "address": "Paris, France",
                "short_address": "France",
                "index": -1,
                "address_components": [
                    { "long_name": "Paris", "short_name": "Paris", "types": ["locality", "political"] },
                    { "long_name": "Île-de-France", "short_name": "IDF", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "France", "short_name": "FR", "types": ["country", "political"] }
                ],
                "formatted_address": "Paris, France",
                "geometry": {
                    "location": { "lat": 48.856614, "lng": 2.3522219 },
                    "viewport": {
                        "northeast": { "lat": 48.9021449, "lng": 2.4699208 },
                        "southwest": { "lat": 48.815573, "lng": 2.224199 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 48.856614, "lng": 2.3522219 },
                "viewport": {
                    "northeast": { "lat": 48.9021449, "lng": 2.4699208 },
                    "southwest": { "lat": 48.815573, "lng": 2.224199 }
                }
            }
        }
    },
    Berlin: {
        title: 'TopDestinations.Berlin',
        sub_title: 'TopDestinations.Berlin_Subtitle',
        destination: {
            "address": "Berlin, Germany",
            "place": {
                "description": "Berlin, Germany",
                "place_id": "ChIJAVkDPzdOqEcRcDteW0YgIQQ",
                "reference": "ChIJAVkDPzdOqEcRcDteW0YgIQQ",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Berlin",
                "label": "Berlin, Germany",
                "address": "Berlin, Germany",
                "short_address": "Germany",
                "index": -1,
                "address_components": [
                    { "long_name": "Berlin", "short_name": "Berlin", "types": ["locality", "political"] },
                    { "long_name": "Berlin", "short_name": "BE", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "Germany", "short_name": "DE", "types": ["country", "political"] }
                ],
                "formatted_address": "Berlin, Germany",
                "geometry": {
                    "location": { "lat": 52.5200066, "lng": 13.404954 },
                    "viewport": {
                        "northeast": { "lat": 52.6755187, "lng": 13.7611609 },
                        "southwest": { "lat": 52.338258, "lng": 13.088345 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 52.5200066, "lng": 13.404954 },
                "viewport": {
                    "northeast": { "lat": 52.6755187, "lng": 13.7611609 },
                    "southwest": { "lat": 52.338258, "lng": 13.088345 }
                }
            }
        }
    },
    LimassolAirHaifa: {
        title: 'TopDestinations.LimassolAirHaifa',
        sub_title: 'TopDestinations.LimassolAirHaifa_Subtitle',
        destination: {
            "address": "Limassol, Cyprus",
            "place": {
                "description": "Limassol, Cyprus",
                "place_id": "ChIJnfQCrBYz5xQRErAlcJV_qdo",
                "reference": "ChIJnfQCrBYz5xQRErAlcJV_qdo",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Limassol",
                "label": "Limassol, Cyprus",
                "address": "Limassol, Cyprus",
                "short_address": "Cyprus",
                "index": -1,
                "address_components": [
                    { "long_name": "Limassol", "short_name": "Limassol", "types": ["locality", "political"] },
                    { "long_name": "Limassol District", "short_name": "Limassol District", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "Cyprus", "short_name": "CY", "types": ["country", "political"] }
                ],
                "formatted_address": "Limassol, Cyprus",
                "geometry": {
                    "location": { "lat": 34.6823761, "lng": 33.0464229 },
                    "viewport": {
                        "northeast": { "lat": 34.7282, "lng": 33.1041 },
                        "southwest": { "lat": 34.6400, "lng": 32.9897 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 34.6823761, "lng": 33.0464229 },
                "viewport": {
                    "northeast": { "lat": 34.7282, "lng": 33.1041 },
                    "southwest": { "lat": 34.6400, "lng": 32.9897 }
                }
            }
        }
    },
    AthensAirHaifa: {
        title: 'TopDestinations.AthensAirHaifa',
        sub_title: 'TopDestinations.AthensAirHaifa_Subtitle',
        destination: {
            "address": "Athens, Greece",
            "place": {
                "description": "Athens, Greece",
                "place_id": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                "reference": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Athens",
                "label": "Athens, Greece",
                "address": "Athens, Greece",
                "short_address": "Greece",
                "index": -1,
                "address_components": [
                    { "long_name": "Athens", "short_name": "Athens", "types": ["locality", "political"] },
                    { "long_name": "Central Athens Regional Unit", "short_name": "Central Athens Regional Unit", "types": ["administrative_area_level_3", "political"] },
                    { "long_name": "Greece", "short_name": "GR", "types": ["country", "political"] }
                ],
                "formatted_address": "Athens, Greece",
                "geometry": {
                    "location": { "lat": 37.9838096, "lng": 23.7275388 },
                    "viewport": {
                        "northeast": { "lat": 38.03285634274878, "lng": 23.7896925212467 },
                        "southwest": { "lat": 37.94881814647892, "lng": 23.68698615988247 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 37.9838096, "lng": 23.7275388 },
                "viewport": {
                    "northeast": { "lat": 38.03285634274878, "lng": 23.7896925212467 },
                    "southwest": { "lat": 37.94881814647892, "lng": 23.68698615988247 }
                }
            }
        }
    },
    RhodesAirHaifa: {
        title: 'TopDestinations.RhodesAirHaifa',
        sub_title: 'TopDestinations.RhodesAirHaifa_Subtitle',
        destination: {
            "address": "Rhodes, Greece",
            "place": {
                "description": "Rhodes, Greece",
                "place_id": "ChIJYf8K4ZNhlRQRk4i_vYjQE2k",
                "reference": "ChIJYf8K4ZNhlRQRk4i_vYjQE2k",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Rhodes",
                "label": "Rhodes, Greece",
                "address": "Rhodes, Greece",
                "short_address": "Greece",
                "index": -1,
                "address_components": [
                    { "long_name": "Rhodes", "short_name": "Rhodes", "types": ["locality", "political"] },
                    { "long_name": "Rhodes", "short_name": "Rhodes", "types": ["administrative_area_level_3", "political"] },
                    { "long_name": "Greece", "short_name": "GR", "types": ["country", "political"] }
                ],
                "formatted_address": "Rhodes, Greece",
                "geometry": {
                    "location": { "lat": 36.4359325, "lng": 28.2172676 },
                    "viewport": {
                        "northeast": { "lat": 36.4586052237461, "lng": 28.24081820191253 },
                        "southwest": { "lat": 36.41289633176704, "lng": 28.20258754462017 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 36.4359325, "lng": 28.2172676 },
                "viewport": {
                    "northeast": { "lat": 36.4586052237461, "lng": 28.24081820191253 },
                    "southwest": { "lat": 36.41289633176704, "lng": 28.20258754462017 }
                }
            }
        }
    },
    PaphosAirHaifa: {
        title: 'TopDestinations.PaphosAirHaifa',
        sub_title: 'TopDestinations.PaphosAirHaifa_Subtitle',
        destination: {
            "address": "Paphos, Cyprus",
            "place": {
                "description": "Paphos, Cyprus",
                "place_id": "ChIJyeIt9GMG5xQR57X0UP_9BWw",
                "reference": "ChIJyeIt9GMG5xQR57X0UP_9BWw",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Paphos",
                "label": "Paphos, Cyprus",
                "address": "Paphos, Cyprus",
                "short_address": "Cyprus",
                "index": -1,
                "address_components": [
                    { "long_name": "Paphos", "short_name": "Paphos", "types": ["locality", "political"] },
                    { "long_name": "Paphos District", "short_name": "Paphos District", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "Cyprus", "short_name": "CY", "types": ["country", "political"] }
                ],
                "formatted_address": "Paphos, Cyprus",
                "geometry": {
                    "location": { "lat": 34.7753635, "lng": 32.4234254 },
                    "viewport": {
                        "northeast": { "lat": 34.8196, "lng": 32.4836 },
                        "southwest": { "lat": 34.7312, "lng": 32.3632 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 34.7753635, "lng": 32.4234254 },
                "viewport": {
                    "northeast": { "lat": 34.8196, "lng": 32.4836 },
                    "southwest": { "lat": 34.7312, "lng": 32.3632 }
                }
            }
        }
    },
    PragueAirHaifa: {
        title: 'TopDestinations.PragueAirHaifa',
        sub_title: 'TopDestinations.PragueAirHaifa_Subtitle',
        destination: {
            "address": "Prague, Czech Republic",
            "place": {
                "description": "Prague, Czech Republic",
                "place_id": "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",
                "reference": "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Prague",
                "label": "Prague, Czech Republic",
                "address": "Prague, Czech Republic",
                "short_address": "Czech Republic",
                "index": -1,
                "address_components": [
                    { "long_name": "Prague", "short_name": "Prague", "types": ["locality", "political"] },
                    { "long_name": "Prague", "short_name": "Prague", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "Czech Republic", "short_name": "CZ", "types": ["country", "political"] }
                ],
                "formatted_address": "Prague, Czech Republic",
                "geometry": {
                    "location": { "lat": 50.0755381, "lng": 14.4378005 },
                    "viewport": {
                        "northeast": { "lat": 50.1774, "lng": 14.7068 },
                        "southwest": { "lat": 49.9419, "lng": 14.2244 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 50.0755381, "lng": 14.4378005 },
                "viewport": {
                    "northeast": { "lat": 50.1774, "lng": 14.7068 },
                    "southwest": { "lat": 49.9419, "lng": 14.2244 }
                }
            }
        }
    },
    DubaiAirHaifa: {
        title: 'TopDestinations.DubaiAirHaifa',
        sub_title: 'TopDestinations.DubaiAirHaifa_Subtitle',
        destination: {
            "address": "Dubai - United Arab Emirates",
            "place": {
                "description": "Dubai - United Arab Emirates",
                "place_id": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "reference": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "types": ["locality", "political"],
                "category": "location",
                "name": "Dubai",
                "label": "Dubai, United Arab Emirates",
                "address": "Dubai - United Arab Emirates",
                "short_address": "United Arab Emirates",
                "index": -1,
                "address_components": [
                    { "long_name": "Dubai", "short_name": "Dubai", "types": ["locality", "political"] },
                    { "long_name": "Dubai", "short_name": "Dubai", "types": ["administrative_area_level_1", "political"] },
                    { "long_name": "United Arab Emirates", "short_name": "AE", "types": ["country", "political"] }
                ],
                "formatted_address": "Dubai - United Arab Emirates",
                "geometry": {
                    "location": { "lat": 25.2048493, "lng": 55.2707828 },
                    "viewport": {
                        "northeast": { "lat": 25.35856066265986, "lng": 55.5650392624228 },
                        "southwest": { "lat": 24.79348418590246, "lng": 54.89045432509004 }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": { "lat": 25.2048493, "lng": 55.2707828 },
                "viewport": {
                    "northeast": { "lat": 25.35856066265986, "lng": 55.5650392624228 },
                    "southwest": { "lat": 24.79348418590246, "lng": 54.89045432509004 }
                }
            }
        }
    }
};

const TOP_DESTINATIONS = [
    {
        id: 'Dubai',
        ...DESTINATIONS_BASE_DATA.Dubai,
        image: `${BASE_PATH}/dubai.jpg`,
        type: SMALL
    },
    {
        id: 'NewYork',
        ...DESTINATIONS_BASE_DATA.NewYork,
        image: `${BASE_PATH}/new-york.jpg`,
        type: SMALL
    },
    {
        id: 'London',
        ...DESTINATIONS_BASE_DATA.London,
        image: `${BASE_PATH}/london.jpg`,
        type: LARGE
    }
];





const EXTENDED_TOP_DESTINATIONS = [
    {
        id: 'NewYork',
        ...DESTINATIONS_BASE_DATA.NewYork,
        image: `${BASE_PATH}/new-york.png`,
        type: SMALL
    },
    {
        id: 'Athens',
        ...DESTINATIONS_BASE_DATA.Athens,
        image: `${BASE_PATH}/athens.png`,
        type: SMALL
    },
    {
        id: 'Dubai',
        ...DESTINATIONS_BASE_DATA.Dubai,
        image: `${BASE_PATH}/dubai.png`,
        type: SMALL
    },
    {
        id: 'KohSamui',
        ...DESTINATIONS_BASE_DATA.KohSamui,
        image: `${BASE_PATH}/koh-samui.png`,
        type: SMALL
    },
    {
        id: 'Budapest',
        ...DESTINATIONS_BASE_DATA.Budapest,
        image: `${BASE_PATH}/budapest.png`,
        type: SMALL
    },
    {
        id: 'Rhodes',
        ...DESTINATIONS_BASE_DATA.Rhodes,
        image: `${BASE_PATH}/rhodes.png`,
        type: SMALL
    }
];

const ELAL_DESTINATIONS = [
    {
        id: 'NewYork',
        ...DESTINATIONS_BASE_DATA.NewYork,
        image: `https://elal-assets.s3.eu-central-1.amazonaws.com/static/new-york.png`,
        type: SMALL
    },
    {
        id: 'Athens',
        ...DESTINATIONS_BASE_DATA.Athens,
        image: `https://elal-assets.s3.eu-central-1.amazonaws.com/static/athenas.png`,
        type: SMALL
    },
    {
        id: 'Paris',
        ...DESTINATIONS_BASE_DATA.Paris,
        image: `https://elal-assets.s3.eu-central-1.amazonaws.com/static/paris.png`,
        type: SMALL
    },
    {
        id: 'KohSamui',
        ...DESTINATIONS_BASE_DATA.KohSamui,
        image: `https://elal-assets.s3.eu-central-1.amazonaws.com/static/koh-samui.png`,
        type: SMALL
    },
        {
        id: 'London',
        ...DESTINATIONS_BASE_DATA.London,
        image: `https://elal-assets.s3.eu-central-1.amazonaws.com/static/london.png`,
        type: SMALL
    },
    {
        id: 'Berlin',
        ...DESTINATIONS_BASE_DATA.Berlin,
        image: `https://elal-assets.s3.eu-central-1.amazonaws.com/static/berlin.png`,
        type: SMALL
    }
];

const AIRHAIFA_TOP_DESTINATIONS = [
    {
        id: 'LimassolAirHaifa',
        ...DESTINATIONS_BASE_DATA.LimassolAirHaifa,
        image: `${AIRHAIFA_BASE_PATH}/limassol.png`,
        type: SMALL
    },
    {
        id: 'AthensAirHaifa',
        ...DESTINATIONS_BASE_DATA.AthensAirHaifa,
        image: `${AIRHAIFA_BASE_PATH}/athens.png`,
        type: SMALL
    },
    {
        id: 'RhodesAirHaifa',
        ...DESTINATIONS_BASE_DATA.RhodesAirHaifa,
        image: `${AIRHAIFA_BASE_PATH}/rhodes.png`,
        type: SMALL
    },
    {
        id: 'PaphosAirHaifa',
        ...DESTINATIONS_BASE_DATA.PaphosAirHaifa,
        image: `${AIRHAIFA_BASE_PATH}/paphos.png`,
        type: SMALL
    },
    {
        id: 'PragueAirHaifa',
        ...DESTINATIONS_BASE_DATA.PragueAirHaifa,
        image: `${AIRHAIFA_BASE_PATH}/prague.png`,
        type: SMALL
    },
    {
        id: 'DubaiAirHaifa',
        ...DESTINATIONS_BASE_DATA.DubaiAirHaifa,
        image: `${AIRHAIFA_BASE_PATH}/dubai.png`,
        type: SMALL
    }
];

module.exports = {
    SMALL,
    LARGE,
    BASE_PATH,
    AIRHAIFA_BASE_PATH,
    DESTINATIONS_BASE_DATA,
    TOP_DESTINATIONS,
    EXTENDED_TOP_DESTINATIONS,
    ELAL_DESTINATIONS,
    AIRHAIFA_TOP_DESTINATIONS
};